import {PayloadAction} from '@reduxjs/toolkit';
import {APP_ERRORS} from 'definitions/errors';

import alerts from 'helpers/alerts';
import {ApiErrors} from "types/global";
import {history} from 'helpers/history';
import ROUTES from "../routes";


export const processError = (action: PayloadAction<ApiErrors>) => {

    if (action.type) {
        history.push(ROUTES.errorPage.path);
    }

    const status = Number(action.payload.code ?? 0);

    const error = Object.values(APP_ERRORS).find((err) => err.codes.includes(status));

    if (error?.redirect) {
        history.push(error?.redirect)
    }

    if (error?.alert) {
        alerts.addCustom({
            type: error.alert,
            message: action.payload.message,
        });
    }


    return action;
};